import { animate, state, style, transition, trigger } from "@angular/animations";

export let FadeInOutAnimation = trigger('fadeInOut', [
  state('void', 
    style({
      opacity: 0,
      visibility: 'hidden',
    })
  ),
  state('*', 
    style({
      opacity: 1,
      visibility: 'visible',
    })
  ),
  transition('void => *', [
    animate('0.2s ease-in', style({
      opacity: 1,
      visibility: 'visible',
    }))
  ]),
  transition('* => void', [
    animate('0.2s ease-out', style({
      opacity: 0,
      visibility: 'hidden',
    }))
  ])
])